import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon8: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#F3123C"
        d="M9.086 15.993a.609.609 0 0 1-.172 0l-.085-.023-.049-.02-.028-.015a12.13 12.13 0 0 1-.386-.235 27.658 27.658 0 0 1-3.957-3.028C1.661 10.131 0 7.45 0 4.713 0 2.11 2.127 0 4.751 0a4.757 4.757 0 0 1 4.25 2.602A4.752 4.752 0 0 1 13.249 0C15.873 0 18 2.11 18 4.713c0 2.737-1.661 5.418-4.409 7.959a27.658 27.658 0 0 1-4.338 3.26.65.65 0 0 1-.082.038l-.085.023ZM9 5.213a.501.501 0 0 1-.503-.5l-.005-.197C8.389 2.558 6.753 1 4.751 1 2.682 1 1.006 2.663 1.006 4.713c0 2.395 1.525 4.857 4.088 7.226a26.548 26.548 0 0 0 3.81 2.915l.097.061.095-.061a26.548 26.548 0 0 0 3.81-2.915c2.563-2.369 4.088-4.831 4.088-7.226 0-2.05-1.676-3.713-3.745-3.713S9.503 2.663 9.503 4.713c0 .276-.225.5-.503.5Z"
      />
    </Svg>
  )
}
